import React from 'react';
import { useSelector } from 'react-redux';
import AddProductForm from '../../Components/AddProductForm/AddProductForm';
import Card from '../../Components/Card/Card';

const AddNewProductPage = () => {
    const { products } = useSelector(state => state)

    return (
        <div>
            <main className="py-16">
                <div className="productWrapper">
                    {/* <!-- products container --> */}
                    <div className="productContainer" id="lws-productContainer">
                        {/* <!-- product item --> */}
                        {
                            products.length ? products.map(single => <Card key={single.id} {...single}></Card>) : <div>
                                No Product Found
                            </div>
                        }
                    </div>
                    {/* <!-- products container ends --> */}
                    <div>
                        {/* <!-- Product Input Form --> */}
                        <AddProductForm></AddProductForm>
                        {/* <!-- Product Input Form Ends --> */}
                    </div>
                </div>
            </main>
        </div>
    );
};

export default AddNewProductPage;